/**
 * Whether `AuthedLayout` should bounce the user back to `/login`.
 *
 * There are two sources of truth for "signed in" right after
 * `resolver.resolveSignIn()` on the TOTP page: the Firebase Auth SDK's
 * `auth.currentUser` (set synchronously once `resolveSignIn` resolves) and
 * this app's React `AuthContext`, which only catches up once its
 * `onAuthStateChanged` listener fires and finishes fetching claims. On the
 * first render after MFA, `contextUser` can still be the login page's
 * original `null` while `loading` has already flipped to `false` from that
 * same earlier event — a state the context never revisits. Trusting
 * `contextUser` alone there bounces a signed-in admin back to `/login`.
 *
 * `sdkUser` (`auth.currentUser`) is authoritative for "signed out"; a
 * lagging context is not. Only bounce when BOTH agree there is no user.
 */
export function shouldBounceToLogin({
  loading,
  contextUser,
  sdkUser,
}: {
  loading: boolean;
  contextUser: unknown;
  sdkUser: unknown;
}): boolean {
  return !loading && !contextUser && !sdkUser;
}
